// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__38TJQ","row":"styles_row__xEzq5"};